export default __webpack_public_path__ + "static/media/block-four-3.9d4f3c75.png";